import MessageTemplatesDataTable from "../../../components/dataTable/tables/MessageTemplatesDataTable";

function MessageTemplatesPageView() {
  return <MessageTemplatesDataTable />;
}

export default MessageTemplatesPageView;
